export const getChameleon = () => window.chmln;